module.exports = __webpack_public_path__ + "static/media/browser-chrome.501834c0.svg";